export const CLINIC_NAME_MIN_LENGTH = 2;
export const CLINIC_NAME_MAX_LENGTH = 50;

const CLINIC_NAME_ALLOWED_REGEX = /^[a-zA-Z0-9\s.,&'()-]+$/;

export type ClinicNameValidationIssue =
  | "required"
  | "tooShort"
  | "tooLong"
  | "onlyNumbers"
  | "invalidChars";

export const validateClinicName = (
  clinicName: string,
): ClinicNameValidationIssue | null => {
  const value = (clinicName ?? "").trim();

  if (!value) return "required";
  if (value.length < CLINIC_NAME_MIN_LENGTH) return "tooShort";
  if (value.length > CLINIC_NAME_MAX_LENGTH) return "tooLong";
  if (/^\d+$/.test(value)) return "onlyNumbers";
  if (!CLINIC_NAME_ALLOWED_REGEX.test(value)) return "invalidChars";

  return null;
};
